import { useSuspenseQuery } from '@tanstack/react-query';
import { createFileRoute, Link, Outlet } from '@tanstack/react-router';
import { twMerge } from 'tailwind-merge';

import { ButtonLink } from '@repo/components/button-link';

import { routesByPath } from '~/config/routes.ts';
import { ContentHeader } from '~/features/content-header/content-header.tsx';
import { queryProjectById } from '~/services/authorization/authorization.ts';

export const Route = createFileRoute('/(user-mgmt)/project/$project/user-mgmt')({
  loader: async ({ context: { queryClient }, params: { project } }) => {
    return queryClient.ensureQueryData(queryProjectById(project));
  },
  component: RouteComponent,
});

function RouteComponent() {
  const projectId = Route.useParams().project;
  const project = useSuspenseQuery(queryProjectById(projectId)).data;

  return (
    <div className="flex flex-col items-start gap-6 pb-6">
      <div className="flex w-full flex-wrap items-start justify-between gap-4">
        <div className="flex flex-col gap-1">
          <ContentHeader>
            User management
          </ContentHeader>
          <p>
            Manage users and roles in
            {' '}
            {project.name}
          </p>
        </div>
        <ButtonLink
          to="/project/$project/user-mgmt-guide"
          params={p => ({ project: p.project ?? '' })}
          variant="soft"
          color="primary"
          size="sm"
          className="w-fit"
        >
          How user management works
        </ButtonLink>
      </div>
      <nav className="w-full border-b border-secondary-200">
        <ul className="flex gap-4">
          {[
            routesByPath['/project/$project/user-mgmt/users'],
            routesByPath['/project/$project/user-mgmt/service-accounts'],
            routesByPath['/project/$project/user-mgmt/roles'],
          ].map(route => (
            <li key={route.path}>
              <Link
                to={route.path}
                params={p => ({ project: p.project ?? '' })}
                className={twMerge(
                  'flex items-center justify-center',
                  'py-2 px-4 leading-none rounded',
                  'hover:bg-primary-100',
                )}
                activeProps={{ className: 'border-b-2 border-b-primary-700 rounded-b-none hover:bg-transparent' }}
              >
                {route.title}
              </Link>
            </li>
          ))}
        </ul>
      </nav>
      <Outlet />
    </div>
  );
}
